import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/StatusResultModal.css";

/**
 * Shared success/error result modal (Generate page pattern).
 * Pass children for richer success content (e.g. prompt stats).
 */
function StatusResultModal({
  open = false,
  type = "error",
  message = "",
  title,
  onClose,
  children,
  zIndex,
}) {
  const { t } = useTranslation("generate");

  if (!open) return null;

  const resolvedType = type === "success" ? "success" : "error";
  const resolvedTitle = title ?? (resolvedType === "success" ? t("modal.success") : t("modal.error"));

  return (
    <div
      className="generate-modal-backdrop"
      style={zIndex != null ? { zIndex } : undefined}
    >
      <div className="generate-modal">
        <div
          className={`generate-modal-header ${
            resolvedType === "success" ? "generate-modal-success" : "generate-modal-error"
          }`}
        >
          <h3 className="generate-modal-title">{resolvedTitle}</h3>
          <button
            type="button"
            className="generate-modal-close"
            aria-label={t("modal.close")}
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <div className="generate-modal-body">
          {message ? <p>{message}</p> : null}
          {children}
        </div>
      </div>
    </div>
  );
}

export default StatusResultModal;
